import { createAction } from 'signin-app/redux/helpers';
const domain = 'CHILD_CHECK_OUT';
export const { action: checkOutChild, success: checkOutChildSuccess, failed: checkOutChildFailed, } = createAction(`${domain}/CHECKOUT`, (childId, pin, kcData) => ({ childId, pin, kcData }), (response) => ({ response }), (error) => ({ error }));
